import React from 'react';
import { useTranslation } from 'react-i18next';
import FadeInSection from './FadeInSection';

const VisionSection: React.FC = () => {
  const { t } = useTranslation('website');

  return (
    <section id="vision" className="py-24 lg:py-32 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <FadeInSection className="max-w-4xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-8 h-[2px] bg-accent-500" />
            <span className="text-accent-400 text-xs font-semibold tracking-wider uppercase">{t('vision.label')}</span>
            <div className="w-8 h-[2px] bg-accent-500" />
          </div>
          <h2 className="text-3xl lg:text-5xl font-extrabold text-white mb-8 leading-snug">
            {t('vision.title')}<br />
            <span className="gradient-text">{t('vision.titleAccent')}</span>
          </h2>
          <p className="text-dark-400 text-lg mb-12 max-w-3xl mx-auto" style={{ lineHeight: '1.9' }}>
            {t('vision.subtitle')}
          </p>

          {/* Vision banner */}
          <FadeInSection delay="fade-in-delay-1" className="relative rounded-3xl overflow-hidden aspect-[21/9] bg-dark-900 border border-dark-800/50 img-overlay">
            <img
              src="/images/vision-banner.png"
              alt="Vision"
              className="w-full h-full object-cover"
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = 'none';
                const fallback = (e.target as HTMLImageElement).nextElementSibling as HTMLElement;
                if (fallback) fallback.style.display = 'flex';
              }}
            />
            <div className="hidden flex-col items-center justify-center h-full gap-4 text-dark-500">
              <i data-lucide="rocket" className="text-5xl text-primary-500/30" />
              <span className="text-sm">Vision Banner</span>
            </div>
          </FadeInSection>
        </FadeInSection>
      </div>
    </section>
  );
};

export default VisionSection;
